export class Legislacao {
    idLegislacao: any;
    dsLegislacao: any;
    flAtivo: any;

    constructor() {
        this.idLegislacao = "";
        this.dsLegislacao = "";
        this.flAtivo = "";
    }
}


// WEBPACK FOOTER //
// ./src/models/Legislacao.ts